import { Route } from 'react-router-dom';
import { parrainagesReconductionsSchema } from './parrainagesReconductions';
import Main from '@app/main/tables/Main';
import ParrainagesReconductionsDetailsEnhanced from './parrainagesReconductionsDetailsEnhanced';

/**
 * Routes configurées pour le module ParrainagesReconductions
 */
const ParrainagesReconductionsRoutes = [
    // Route de liste (principale)
    <Route
        key="parrainages-reconductions-list"
        path="parrainagesReconductions"
        element={
            <Main
                key="parrainages-reconductions-main"
                pageConfig={parrainagesReconductionsSchema}
            />
        }
    />,

    // Route pour les détails d'un potentiel parrainage
    <Route
        key="parrainages-reconductions-details"
        path="parrainagesReconductions/:id/details"
        element={<ParrainagesReconductionsDetailsEnhanced />}
    />,

    <Route
        key="parrainages-reconductions-modifie-list"
        path="parrainagesReconductions"
        element={<Main
                key="parrainages-reconductions-main"
                pageConfig={parrainagesReconductionsSchema}
            />
        }
    />,

    <Route
        key="parrainages-reconductions-modifie-details"
        path="parrainagesReconductionsModifie/:id/details"
        element={<ParrainagesReconductionsDetailsEnhanced />}
    />,
];

export default ParrainagesReconductionsRoutes;
